import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { TableProps } from 'antd';
import React, { memo } from 'react';
import { Rows } from './Row';
import type { Reference } from 'rc-table';
import TableComponent from './TableComponent';

export interface DragIndex {
  activeIndex?: number;
  overIndex?: number;
}
interface ExtendedTableProps
  extends React.PropsWithChildren<TableProps>,
    React.RefAttributes<Reference> {
  setDataSource: (data: any) => void;
  onChangeRow?: (dragIndex: DragIndex) => void;
}

const TableMoveRow = memo((tableProps: ExtendedTableProps) => {
  const { Row, onDragEnd } = Rows;
  return (
    <DndContext
      modifiers={[restrictToVerticalAxis]}
      onDragEnd={(e) => {
        const { activeIndex, overIndex } = onDragEnd(
          e,
          tableProps.setDataSource,
          tableProps?.rowKey,
        );
        tableProps.onChangeRow &&
          tableProps.onChangeRow({ activeIndex, overIndex });
      }}
    >
      <SortableContext
        items={
          tableProps.dataSource?.map(
            (i: any) => i?.[tableProps.rowKey?.toString() || 'id'],
          ) || []
        }
        strategy={verticalListSortingStrategy}
      >
        <TableComponent
          rowKey="id"
          components={{ body: { row: Row } }}
          {...tableProps}
        />
      </SortableContext>
    </DndContext>
  );
});

export default memo(TableMoveRow);
